// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel, { EmblaCarouselType } from "embla-carousel";

Alpine.directive("slider-double-row", (element, {}, { cleanup }) => {
  const OPTIONS = { align: "start", loop: true } as const;

  const dom = {
    viewportTopNode: ensureHTMLElement(element.querySelector(".c-slider-double-row__slider-top-viewport")),
    viewportBottomNode: ensureHTMLElement(
      element.querySelector(".c-slider-double-row__slider-bottom-viewport"),
    ),
    slidesContainerTop: ensureHTMLElement(
      element.querySelector(".c-slider-double-row__slider-top-container"),
    ),
    slidesContainerBottom: ensureHTMLElement(
      element.querySelector(".c-slider-double-row__slider-bottom-container"),
    ),
    nextBtnNode: ensureHTMLElement(element.querySelector(".c-slider-double-row__btn-next")),
    prevBtnNode: ensureHTMLElement(element.querySelector(".c-slider-double-row__btn-prev")),
  };

  function duplicateSlides(container: HTMLElement) {
    const originalSlides = Array.from(container.children);
    const minSlides = 12;

    if (originalSlides.length === 0) return;

    while (container.children.length < minSlides) {
      for (const slide of originalSlides) {
        const clone = slide.cloneNode(true) as HTMLElement;
        container.appendChild(clone);
        if (container.children.length >= minSlides) break;
      }
    }
  }

  duplicateSlides(dom.slidesContainerTop);
  duplicateSlides(dom.slidesContainerBottom);

  const sliderTop = EmblaCarousel(dom.viewportTopNode, OPTIONS);
  const sliderBottom = EmblaCarousel(dom.viewportBottomNode, OPTIONS);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(sliderTop, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  const readDirection = (embla: EmblaCarouselType) => {
    const { target, location } = embla.internalEngine();
    const diffToTarget = target.get() - location.get();
    return -1 * Math.sign(diffToTarget);
  };

  let isAutoSliding = false;

  sliderTop.on("select", () => {
    const direction = Number(readDirection(sliderTop) > 0);
    const nextOrPrev = ["scrollNext", "scrollPrev"][direction];
    isAutoSliding = true;
    sliderBottom[nextOrPrev]();
    isAutoSliding = false;
  });

  sliderBottom.on("select", () => {
    if (!isAutoSliding) {
      const direction = Number(readDirection(sliderBottom) > 0);
      const nextOrPrev = ["scrollNext", "scrollPrev"][direction];
      sliderTop[nextOrPrev]();
    }
  });

  sliderTop.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    sliderTop.destroy();
    sliderBottom.destroy();
  });
});
